export default class ObjectUtilities {
    static defineObjectProperties(obj: any, path: string[], value: any) {
        let current = obj;
        for (let i = 0; i < path.length; i++) {
            if (!current[path[i]]) {
                current[path[i]] = {};
            }
            if (i === path.length - 1 && value != undefined) {
                current[path[i]] = value;
            }

            current = current[path[i]];
        }
    }

    static getObjectValue(obj: any, path: string[]) {
        let current = {
            ...obj
        };
        for (let i = 0; i < path.length; i++) {
            if (!current[path[i]]) {
                return undefined;
            }

            if (i === path.length - 1) return current[path[i]];

            current = {
                ...current[path[i]]
            };
        }

        return current;
    }
}
